import React from "react";
import { NavLink } from "react-router-dom";

import { REAL_ESTATE_TABS } from "@features/real-estate/state/constants";
import type { RealEstateEnrichmentState } from "@features/real-estate/types";

type RealEstateWorkspaceShellProps = {
  title: string;
  description: string;
  enrichmentState: RealEstateEnrichmentState;
  children: React.ReactNode;
};

export function RealEstateWorkspaceShell({
  title,
  description,
  enrichmentState,
  children,
}: RealEstateWorkspaceShellProps): React.ReactElement {
  return (
    <div className="real-estate-page">
      <div className="real-estate-shell">
        <header className="real-estate-header">
          <div>
            <div className="re-eyebrow">Stateless Underwriting Workspace</div>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
          <div className={`re-status re-status-${enrichmentState}`}>
            <span>Context</span>
            <strong>{labelForEnrichmentState(enrichmentState)}</strong>
          </div>
        </header>

        <nav className="real-estate-tabs" aria-label="Real estate workflow tabs">
          {REAL_ESTATE_TABS.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) => `real-estate-tab${isActive ? " active" : ""}`}
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>

        <main className="real-estate-body">
          {children}
        </main>
      </div>
    </div>
  );
}

function labelForEnrichmentState(state: RealEstateEnrichmentState): string {
  switch (state) {
    case "loading":
      return "Loading";
    case "ready":
      return "Loaded";
    case "error":
      return "Needs retry";
    default:
      return "Not run";
  }
}
